import React from 'react';
import PropTypes from 'prop-types';

import {
  FIELD_IDS,
  FIELD_NAMES,
  FIELD_TITLE_DESCRIPTIONS,
  FIELD_TITLES,
} from '@@vap-svc/constants';
import ProfileInformationFieldController from '@@vap-svc/components/ProfileInformationFieldController';
import { formatAddressTitle } from '@@vap-svc/util/contact-information/addressUtils';

import CopyAddressModalController from './CopyAddressModalController';
import { HeadingLevel, ProfileInfoSection } from '../../ProfileInfoSection';
import BadAddressAlert from '../../alerts/bad-address/FormAlert';

const generateRows = showBadAddress => [
  {
    title: formatAddressTitle(FIELD_TITLES[FIELD_NAMES.MAILING_ADDRESS]),
    description: FIELD_TITLE_DESCRIPTIONS[FIELD_NAMES.MAILING_ADDRESS],
    id: FIELD_IDS[FIELD_NAMES.MAILING_ADDRESS],
    value: (
      <ProfileInformationFieldController
        fieldName={FIELD_NAMES.MAILING_ADDRESS}
        ariaDescribedBy={`described-by-${FIELD_NAMES.MAILING_ADDRESS}`}
      />
    ),
    alertMessage: showBadAddress ? <BadAddressAlert /> : null,
  },
  {
    title: formatAddressTitle(FIELD_TITLES[FIELD_NAMES.RESIDENTIAL_ADDRESS]),
    description: FIELD_TITLE_DESCRIPTIONS[FIELD_NAMES.RESIDENTIAL_ADDRESS],
    id: FIELD_IDS[FIELD_NAMES.RESIDENTIAL_ADDRESS],
    value: (
      <ProfileInformationFieldController
        fieldName={FIELD_NAMES.RESIDENTIAL_ADDRESS}
      />
    ),
  },
];

const AddressesTable = ({ className, showBadAddress }) => {
  return (
    <>
      <CopyAddressModalController />

      <HeadingLevel className="vads-u-margin-top--4" id="addresses" level={2}>
        Addresses
      </HeadingLevel>

      <va-details label="Where your address won't be updated">
        <p>
          These departments keep your contact information in their own separate
          systems:
        </p>
        <ul>
          <li>Home loan benefits</li>
          <li>CHAMPVA</li>
          <li>The Foreign Medical Program</li>
          <li>Life insurance benefits</li>
        </ul>
        <p>
          <va-link
            href="/resources/change-your-address-on-file-with-va/#change-your-address-by-contact"
            text="Learn how to change your address on file with these departments"
          />
        </p>
      </va-details>

      <ProfileInfoSection
        data={generateRows(showBadAddress)}
        className={className}
        level={2} // Sets each looped row's title to an h3
      />
    </>
  );
};

AddressesTable.propTypes = {
  className: PropTypes.string,
  showBadAddress: PropTypes.bool,
};

export default AddressesTable;
